import { ROUTES } from "@/constants/routes.constants";

export type RegisterFeedbackLocationState = {
  username?: string;
};

export function getRegisterFeedbackEntryNavigation(username?: string): {
  route: string;
  state?: { username: string };
} {
  return username
    ? { route: ROUTES.REGISTER_FEEDBACK, state: { username } }
    : { route: ROUTES.REGISTER_FEEDBACK };
}

export function getRegisterFeedbackExitNavigation(username?: string): {
  route: string;
  state?: { username: string };
} {
  return username
    ? { route: ROUTES.REGISTER_SUCCESS, state: { username } }
    : { route: ROUTES.REGISTER_SUCCESS };
}
